import { Navigate } from 'react-router-dom';

export const SmartRedirect = () => {
  return <Navigate to="/admin/dashboard" replace />;
};
